import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useNotifications } from "@/hooks/useNotifications";

interface Gym {
  id: string;
  name: string;
  logo_url: string | null;
  address: string;
}

export const useMonitorGym = (userId: string | null, initialGymId: string | null) => {
  const [gym, setGym] = useState<Gym | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { error: showError, success } = useNotifications();

  // Load gym data if user has gym_id
  useEffect(() => {
    const loadGym = async () => {
      if (!initialGymId) {
        setIsLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('gyms')
          .select('id, name, logo_url, address')
          .eq('id', initialGymId)
          .single();

        if (error) throw error;
        setGym(data);
      } catch (err) {
        console.error("Error loading gym:", err);
      } finally {
        setIsLoading(false);
      }
    };

    loadGym();
  }, [initialGymId]);

  // Assign gym to monitor
  const assignGym = async (gymId: string) => {
    if (!userId) return false;

    try {
      // Get gym data first
      const { data: gymData, error: gymError } = await supabase
        .from('gyms')
        .select('id, name, logo_url, address')
        .eq('id', gymId)
        .single();

      if (gymError) throw gymError;

      // Update profile with gym_id
      const { error: updateError } = await supabase
        .from('profiles')
        .update({ gym_id: gymId })
        .eq('id', userId);

      if (updateError) throw updateError;

      setGym(gymData);
      success("Gimnasio asignado correctamente");
      return true;
    } catch (err) {
      console.error("Error assigning gym:", err);
      showError("Error al asignar el gimnasio");
      return false;
    }
  };

  return { gym, isLoading, assignGym };
};
